import { useState } from "react";
import { Link } from "react-router-dom";
import { Sparkles, Menu, X } from "lucide-react";
import { Button } from "@/components/ui/button";
import TrialSignupDialog from "@/components/TrialSignupDialog";

const links = [
  { label: "Features", href: "#features" },
  { label: "How it works", href: "#how" },
  { label: "Calculator", href: "#calculator" },
  { label: "Pricing", href: "#pricing" },
  { label: "FAQ", href: "#faq" },
];

export default function Nav() {
  const [open, setOpen] = useState(false);
  const [trialOpen, setTrialOpen] = useState(false);

  return (
    <header className="sticky top-0 z-50 backdrop-blur-xl bg-[#FAF7F0]/80 border-b border-[#183D36]/10">
      <div className="max-w-7xl mx-auto px-6 sm:px-10 lg:px-16 h-16 flex items-center justify-between">
        <Link to="/" data-testid="nav-logo" className="flex items-center gap-2">
          <span className="w-8 h-8 rounded-2xl bg-[#183D36] text-[#F4B183] flex items-center justify-center">
            <Sparkles size={16} strokeWidth={2} />
          </span>
          <span className="font-heading text-lg font-semibold text-[#183D36] tracking-tight">NextVisit</span>
        </Link>

        <nav className="hidden md:flex items-center gap-8">
          {links.map((l) => (
            <a
              key={l.href}
              href={l.href}
              data-testid={`nav-link-${l.href.slice(1)}`}
              className="text-sm text-[#252525] hover:text-[#183D36] transition-colors font-medium"
            >
              {l.label}
            </a>
          ))}
        </nav>

        <div className="hidden md:flex items-center gap-3">
          <Button
            data-testid="nav-signin-btn"
            variant="ghost"
            asChild
            className="rounded-full text-[#252525] hover:bg-[#EFECE5]"
          >
            <Link to="/admin">Sign in</Link>
          </Button>
          <Button
            data-testid="nav-start-free-btn"
            onClick={() => setTrialOpen(true)}
            className="rounded-full bg-[#183D36] hover:bg-[#122e29] text-[#FAF7F0] px-5"
          >
            Start free
          </Button>
        </div>

        <button
          data-testid="nav-mobile-toggle"
          className="md:hidden text-[#183D36]"
          onClick={() => setOpen(!open)}
          aria-label="Menu"
        >
          {open ? <X size={22} /> : <Menu size={22} />}
        </button>
      </div>

      {open && (
        <div className="md:hidden border-t border-[#183D36]/10 bg-[#FAF7F0]">
          <div className="px-6 py-4 flex flex-col gap-3">
            {links.map((l) => (
              <a
                key={l.href}
                href={l.href}
                onClick={() => setOpen(false)}
                className="text-[#252525] py-2"
              >
                {l.label}
              </a>
            ))}
            <Button
              data-testid="nav-mobile-signin-btn"
              variant="ghost"
              asChild
              className="rounded-full border border-[#183D36]/20 text-[#252525]"
            >
              <Link to="/admin" onClick={() => setOpen(false)}>Sign in</Link>
            </Button>
            <Button
              data-testid="nav-mobile-start-btn"
              onClick={() => { setOpen(false); setTrialOpen(true); }}
              className="rounded-full bg-[#183D36] hover:bg-[#122e29] text-[#FAF7F0]"
            >
              Start free
            </Button>
          </div>
        </div>
      )}

      <TrialSignupDialog open={trialOpen} onOpenChange={setTrialOpen} />
    </header>
  );
}
